// import { optionsForModalWindow } from "../basesBuildings/ModalWindow/constansForModalWindow";
import store from "../../../redux/store";
import InspectionTechnicalConditionBases from "../../checksAuditsComponents/inspectionTechnicalConditionBases/inspectionTechnicalConditionBases";

export const inputsHeadersSmallBoats = {
  ownerSurname: {
    key: "ownerSurname",
    value: "Фамилия",
    type: "text",
  },
  ownerName: {
    key: "ownerName",
    value: "Имя",
    type: "text",
  },
  ownerMidname: {
    key: "ownerMidname",
    value: "Отчество",
    type: "text",
  },
  regNum: {
    key: "regNum",
    value: "Рег. номер судна",
    description: "В формате XX 1111",
    type: "text",
  },
  leName: {
    key: "leName",
    value: "Наим. организации",
    type: "text",
  },
  leUnp: {
    key: "leUnp",
    value: "УНП",
    type: "text",
  },
  engvin: {
    key: "engvin",
    value: "Заводской номер двигателя",
    type: "text",
  },
  boatVin: {
    key: "boatVin",
    value: "Заводской номер судна",
    description: "Цифры и латиница",
    type: "text",
  },
  cardStatusCode: {
    key: "cardStatusCode",
    value: "Статус карточки",
    type: "select",
    selectOption: [
      { id: 1, value: "Активная" },
      { id: 0, value: "Архивная" },
      { id: 2, value: "Все" },
    ],
  },
};

export const inputsHeadersCertificates = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  licenseNum: {
    key: "licenseNum",
    value: "Номер удост.",
    type: "text",
  },
  persNum: {
    key: "persNum",
    value: "Ид. номер",
    description: "В формате 1111111X111XX1",
    type: "text",
  },
  isActive: {
    key: "isActive",
    value: "Статус карточки",
    type: "select",
    selectOption: [
      { id: 1, value: "Активная" },
      { id: 0, value: "Архивная" },
      { id: 2, value: "Все" },
    ],
  },
};

export const inputsHeadersBasesBuildings = {
  ownerCommonName: {
    key: "ownerCommonName",
    value: "Наименование ЮЛ, ФИО эксплуатанта",
    type: "text",
  },
  ownerUnp: {
    key: "ownerUnp",
    value: "УНП",
    type: "text",
  },
  location: {
    key: "location",
    value: "Местонах.\n" + "базы",
    type: "text",
  },
  startDate: {
    key: "startDate",
    value: "Дата последнего обследования от",
    type: "date",
  },
  endDate: {
    key: "endDate",
    value: "Дата последнего обследования до",
    type: "date",
  },
  checkStatus: {
    key: "checkStatus",
    value: "Результат обследования",
    type: "select",
    selectOption: [{ id: 0, value: "" }],
  },
};

export const inputsHeadersSmallBoatsRegistration = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  appNum: {
    key: "appNum",
    value: "Рег. номер заявления",
    type: "text",
  },
  unp: {
    key: "unp",
    value: "УНП",
    type: "text",
  },
  nameLe: {
    key: "nameLe",
    value: "Наименование организации",
    type: "text",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  status: {
    key: "status",
    value: "Статус",
    type: "select",
    selectOption: [
      { id: 0, value: "Все" },
      { id: 3, value: "К выдаче" },
      { id: 1, value: "Зарегистрировано" },
      { id: 2, value: "Отказано" },
    ],
  },
};
export const inputsRegInformChange = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  appNum: {
    key: "appNum",
    value: "Рег. номер заявления",
    type: "text",
  },
  nameLe: {
    key: "nameLe",
    value: "Наименование организации",
    type: "text",
  },
  unp: {
    key: "unp",
    value: "УНП",
    type: "text",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  status: {
    key: "status",
    value: "Статус",
    type: "select",
    selectOption: [
      { id: 0, value: "Все" },
      { id: 1, value: "Зарегистрировано" },
      { id: 2, value: "Отказано" },
      { id: 3, value: "К выдаче" },
      { id: 4, value: "АП завершена" },
    ],
  },
};
export const inputsFindBoatToChange = {
  ownerSurname: {
    key: "ownerSurname",
    value: "Фамилия",
    type: "text",
  },
  ownerName: {
    key: "ownerName",
    value: "Имя",
    type: "text",
  },
  ownerMidname: {
    key: "ownerMidname",
    value: "Отчество",
    type: "text",
  },
  regNum: {
    key: "regNum",
    value: "Рег. номер судна",
    description: "В формате XX 1111",
    type: "text",
  },
  leName: {
    key: "leName",
    value: "Наим. организации",
    type: "text",
  },
  leUnp: {
    key: "leUnp",
    value: "УНП организации",
    type: "text",
  },
  boatVin: {
    key: "boatVin",
    value: "Зав. номер судна",
    description: "Цифры и латиница",
    type: "text",
  },
  engvin: {
    key: "engvin",
    value: "Заводской номер двигателя",
    description: "Цифры и латиница",
    type: "text",
  },
};
export const inputsFindBoatDuplShipTicket = {
  ownerSurname: {
    key: "ownerSurname",
    value: "Фамилия",
    type: "text",
  },
  ownerName: {
    key: "ownerName",
    value: "Имя",
    type: "text",
  },
  ownerMidname: {
    key: "ownerMidname",
    value: "Отчество",
    type: "text",
  },
  regNum: {
    key: "regNum",
    value: "Рег. номер судна",
    description: "В формате XX 1111",
    type: "text",
  },
  boatVin: {
    key: "boatVin",
    value: "Зав. номер судна",
    description: "Цифры и латиница",
    type: "text",
  },
  engvin: {
    key: "engvin",
    value: "Заводской номер двигателя",
    description: "Цифры и латиница",
    type: "text",
  },
};

export const inputsHeadersDuplicateShipsTicket = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  appNum: {
    key: "regNum",
    value: "Рег. номер судна",
    type: "text",
  },
  // unp: {
  //   key: "unp",
  //   value: "УНП",
  //   type: "text",
  // },
  // nameLe: {
  //   key: "nameLe",
  //   value: "Наименование организации",
  //   type: "text",
  // },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  status: {
    key: "status",
    value: "Статус",
    type: "select",
    selectOption: [
      { id: 0, value: "Все" },
      { id: 3, value: "К выдаче" },
      { id: 8, value: "Выдан" },
      { id: 2, value: "Отказано" },
      { id: 1, value: "Зарегистрировано" },
    ],
  },
};
export const inputsHeadersShipsTicket = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  //Это что за хрень проверить
  appNum: {
    //Это что за хрень проверить
    key: "appNum",
    value: "Рег. номер судна",
    type: "text",
  },
  unp: {
    key: "unp",
    value: "УНП",
    type: "text",
  },
  nameLe: {
    key: "nameLe",
    value: "Наименование организации",
    type: "text",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  status: {
    key: "status",
    value: "Статус",
    type: "select",
    selectOption: [
      { id: 0, value: "Все" },
      { id: 3, value: "К выдаче" },
      { id: 8, value: "Выдан" },
      { id: 2, value: "Отказано" },
    ],
  },
};
export const inputsProvisionInformation = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  appNum: {
    key: "appNum",
    value: "Рег. номер заявления",
    type: "text",
  },
  nameLe: {
    key: "nameLe",
    value: "Наименование организации",
    type: "text",
  },
  unp: {
    key: "unp",
    value: "УНП",
    type: "text",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  status: {
    key: "status",
    value: "Статус",
    type: "select",
    selectOption: [
      { id: 0, value: "Все" },
      { id: 1, value: "Зарегистрировано" },
      { id: 4, value: "АП Завершена" },
    ],
  },
};

export const inputsHeadersTransportAccidentsReport = {
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  ownerSurname: {
    key: "ownerSurname",
    value: "Фамилия судовладельца",
    type: "text",
  },
  ownerName: {
    key: "ownerName",
    value: "Имя судовладельца",
    type: "text",
  },
  ownerMidname: {
    key: "ownerMidname",
    value: "Отчество судовладельца",
    type: "text",
  },
  boatRegNum: {
    key: "boatRegNum",
    value: "Регистрационный номер судна",
    type: "text",
  },
  incidentType: {
    key: "incidentType",
    value: "Вид транспортного аварийного случая",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "incidentType" },
      { value: 1, label: "Авария", key: "incidentType" },
      { value: 2, label: "Инцидент", key: "incidentType" },
    ],
  },
  incidentPlace: {
    key: "incidentPlace",
    value: "Место транспортного аварийного случая",
    type: "text",
  },
  date1: {
    key: "date1",
    value: "Дата с",
    type: "date",
  },
  date2: {
    key: "date2",
    value: "Дата по",
    type: "date",
  },
  driverDrunk: {
    key: "driverDrunk",
    value: "Алкогольное опьянение",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "driverDrunk" },
      { value: true, label: "Да", key: "driverDrunk" },
      { value: false, label: "Нет", key: "driverDrunk" },
    ],
  },
};

export const inputsTechnicalExamination = {
  ownerSurname: {
    key: "ownerSurname",
    value: "Фамилия",
    type: "text",
  },
  ownerName: {
    key: "ownerName",
    value: "Имя",
    type: "text",
  },
  ownerMidname: {
    key: "ownerMidname",
    value: "Отчество",
    type: "text",
  },
  appNum: {
    key: "appNum",
    value: "Рег. номер заявления",
    type: "text",
  },
  leName: {
    key: "leName",
    value: "Наименование организации",
    type: "text",
  },
  leUnp: {
    key: "leUnp",
    value: "УНП",
    type: "text",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  status: {
    key: "status",
    value: "Статус",
    type: "select",
    selectOption: [
      { id: 0, value: "Все" },
      { id: 5, value: "МС Годное" },
      { id: 6, value: "МС Негодное" },
      { id: 7, value: "Устранение замечаний" },
      { id: 2, value: "Отказано" },
    ],
  },
};
export const inputsIssuingCertificates = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  status: {
    key: "status",
    value: "Статус заявления",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "status" }],
  },
  licenseType: {
    key: "licenseType",
    value: "Тип удостоверения",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "licenseType" },
      { value: 1, label: "Республиканское", key: "licenseType" },
      { value: 2, label: "Международное", key: "licenseType" },
    ],
  },
};
export const inputsFormSearchApplicant = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  programId: {
    key: "programId",
    value: "Программа подготовки",
    type: "selectSearch",
    selectOption: [{ value: null, label: "Все", key: "programId" }],
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: null, label: "Все", key: "section" }],
  },
};
export const inputsApplicationTraining = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  programId: {
    key: "programId",
    value: "Программа подготовки",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "programId" }],
  },
};
export const inputsExpulsionOrder = {
  orderNum: {
    key: "orderNum",
    value: "Номер приказа",
    type: "text",
  },
  orderDate: {
    key: "orderDate",
    value: "Дата приказа",
    type: "date",
  },
  startDate: {
    key: "startDate",
    value: "Период обучения с",
    type: "date",
  },
  endDate: {
    key: "endDate",
    value: "Период обучения по",
    type: "date",
  },
};
export const inputsSearchListener = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  startDate: {
    key: "startDate",
    value: "Период обучения с",
    type: "date",
  },
  endDate: {
    key: "endDate",
    value: "Период обучения по",
    type: "date",
  },
};
export const inputsRegisterOfTrainees = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  persNum: {
    key: "persNum",
    value: "Идентификационный номер",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  startDate: {
    key: "startDate",
    value: "Дата подачи заявления с",
    type: "date",
  },
  endDate: {
    key: "endDate",
    value: "Дата подачи заявления по",
    type: "date",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
};
export const inputsRecordTrainedUsersLogbook = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  trainingOrgsId: {
    key: "trainingOrgsId",
    value: "Организация, осуществившая обучение",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "trainingOrgsId" },
      { value: 1, label: "ГИМС", key: "trainingOrgsId" },
      { value: 2, label: "иное учреждение образования", key: "trainingOrgsId" },
    ],
  },
  trainingProgId: {
    key: "trainingProgId",
    value: "Программа подготовки",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "trainingProgId" }],
  },

  trainingDocumentsDateStart: {
    key: "trainingDocumentsDateStart",
    value: "Дата прохождения обучения с",
    type: "date",
  },
  trainingDocumentsDateEnd: {
    key: "trainingDocumentsDateEnd",
    value: "Дата прохождения обучения по",
    type: "date",
  },
};

export const inputsSearchRecordTrainedUsers = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  trainingOrgsName: {
    key: "trainingOrgsName",
    value: "Организация, осуществившая обучение",
    type: "text",
  },
  trainingProgId: {
    key: "trainingProgId",
    value: "Программа подготовки",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "trainingProgId" }],
  },
  trainingDocumentsDateStart: {
    key: "trainingDocumentsDateStart",
    value: "Период обучения с",
    type: "date",
  },
  trainingDocumentsDateEnd: {
    key: "trainingDocumentsDateEnd",
    value: "Период обучения по",
    type: "date",
  },
};

export const inputsAppKnowledgeVerification = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  programId: {
    key: "programId",
    value: "Программа подготовки",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "programId" }],
  },
};

export const inputsSearchKnoweledgeTestRecord = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  programId: {
    key: "programId",
    value: "Программа подготовки",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "programId" }],
  },
  e1PassName: {
    key: "e1PassName",
    value: "Отметка, теория",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "e1PassName" },
      { value: 1, label: "Зачтено", key: "e1PassName" },
      { value: 2, label: "Не зачтено", key: "e1PassName" },
    ],
  },
  e2PassName: {
    key: "e2PassName",
    value: "Отметка, практика",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "e2PassName" },
      { value: 3, label: "В процессе сдачи", key: "e2PassName" },
      { value: 1, label: "Зачтено", key: "e2PassName" },
      { value: 2, label: "Не зачтено", key: "e2PassName" },
    ],
  },
  checkPassName: {
    key: "checkPassName",
    value: "Результат проверки",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "checkPassName" },
      { value: 1, label: "Зачтено", key: "checkPassName" },
      { value: 2, label: "Не зачтено", key: "checkPassName" },
    ],
  },
  protNum: {
    key: "protNum",
    value: "Номер протокола",
    type: "text",
  },
  protDate: {
    key: "protDate",
    value: "Дата протокола",
    type: "date",
  },
};
export const inputsSearchPeopleForTest = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  selfTraining: {
    key: "selfTraining",
    value: "Самоподготовка",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "selfTraining" },
      { value: 1, label: "Да", key: "selfTraining" },
      { value: 2, label: "Нет", key: "selfTraining" },
    ],
  },
};
export const inputsSearchCertificatesForPrint = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  apptype: {
    key: "apptype",
    value: "Административная процедура",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "apptype" },
      { value: 1, label: "Выдача", key: "apptype" },
      { value: 2, label: "Дубликат", key: "apptype" },
      { value: 3, label: "Обмен", key: "apptype" },
    ],
  },
  appDate: {
    key: "appDate",
    value: "Дата рег.заявления",
    type: "date",
  },
  status: {
    key: "status",
    value: "Статус заявления",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "status" }],
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  licenseType: {
    key: "licenseType",
    value: "Тип удостоверения",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "licenseType" },
      { value: 1, label: "Республиканское", key: "licenseType" },
      { value: 2, label: "Международное", key: "licenseType" },
    ],
  },
};

export const inputsInspectionTechnicalConditionBases = {
  ownerLeName: {
    key: "ownerLeName",
    value: "Наименование эксплуатанта",
    type: "text",
  },
  location: {
    key: "location",
    value: "Местонахождение базы",
    type: "text",
  },
  checkStatus: {
    key: "checkStatus",
    value: "Результат обследования",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "checkStatus" }],
  },
  startDate: {
    key: "startDate",
    value: "Дата обследования с",
    type: "date",
  },
  endDate: {
    key: "endDate",
    value: "Дата обследования по",
    type: "date",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: null, label: "Все", key: "section" }],
  },
};

export const inputsLogbookAdministrativeProcedures = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  apcode: {
    key: "apcode",
    value: "Наименование административной процедуры",
    type: "selectSearch",
    selectOption: [{ value: null, label: "Все", key: "apcode" }],
  },
  leName: {
    key: "leName",
    value: "Наименование организации",
    type: "text",
  },
  leUnp: {
    key: "leUnp",
    value: "УНП",
    type: "text",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: null, label: "Все", key: "section" }],
  },
  dateStart: {
    key: "dateStart",
    value: "Дата подачи с",
    type: "date",
  },
  dateEnd: {
    key: "dateEnd",
    value: "Дата подачи по",
    type: "date",
  },
};

export const setOptionsForInputs = (nsiCheckStatusOptions) => {
  if (inputsHeadersBasesBuildings.checkStatus.selectOption.length === 1) {
    inputsHeadersBasesBuildings.checkStatus.selectOption.push(...nsiCheckStatusOptions);
  }
};
export const inputsExchangeCertificates = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  status: {
    key: "status",
    value: "Статус заявления",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "status" }],
  },
  licenseNum: {
    key: "licenseNum",
    value: "Номер удостоверения",
    type: "text",
  },
  licenseDate: {
    key: "licenseDate",
    value: "Дата  удостоверения",
    type: "date",
  },
  licenseType: {
    key: "licenseType",
    value: "Тип удостоверения",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "licenseType" },
      { value: 1, label: "Республиканское", key: "licenseType" },
      { value: 2, label: "Международное", key: "licenseType" },
    ],
  },
};
export const inputsDuplicateCertificates = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
  },
  section: {
    key: "section",
    value: "Участок",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "section" }],
  },
  status: {
    key: "status",
    value: "Статус заявления",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Все", key: "status" }],
  },
  licenseNum: {
    key: "licenseNum",
    value: "Номер удостоверения",
    type: "text",
  },
  licenseDate: {
    key: "licenseDate",
    value: "Дата  удостоверения",
    type: "date",
  },
  licenseType: {
    key: "licenseType",
    value: "Тип удостоверения",
    type: "selectSearch",
    selectOption: [
      { value: 0, label: "Все", key: "licenseType" },
      { value: 1, label: "Республиканское", key: "licenseType" },
      { value: 2, label: "Международное", key: "licenseType" },
    ],
  },
};
export const inputsAuditActionsSystem = {
  fio: {
    key: "fio",
    value: "Пользователь",
    type: "text",
  },
  objectName: {
    key: "objectName",
    value: "Объект учета",
    type: "selectSearch",
    selectOption: [
      { value: 1, label: "Республиканское", key: "licenseType" },
      { value: 2, label: "Международное", key: "licenseType" },
    ],
  },
  logDocNum: {
    key: "logDocNum",
    value: "Номер объекта",
    type: "text",
  },
};
export const inputsSettlements = {
  oblast: {
    key: "oblast",
    value: "Область",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Не выбрано", key: "oblast" }],
  },
  rayon: {
    key: "rayon",
    value: "Район",
    type: "selectSearch",
    selectOption: [{ value: 0, label: "Не выбрано", key: "rayon" }],
  },
  nameRu: {
    key: "nameRu",
    value: "Населенный пункт",
    type: "text",
  },
};

export const setOptionsForInputsTrainingProgram = (inputsOptions, path) => {
  switch (path) {
    case "applicationfortraining":
      if (inputsApplicationTraining.programId.selectOption.length === 1) {
        inputsApplicationTraining.programId.selectOption.push(...inputsOptions);
      }
      break;
    case "record-trained-user-logbook":
      if (inputsRecordTrainedUsersLogbook.trainingProgId.selectOption.length === 1) {
        inputsRecordTrainedUsersLogbook.trainingProgId.selectOption.push(...inputsOptions);
      }
      break;
    case "record-trained-users":
      if (inputsSearchRecordTrainedUsers.trainingProgId.selectOption.length === 1) {
        inputsSearchRecordTrainedUsers.trainingProgId.selectOption.push(...inputsOptions);
      }
      break;
    case "app-knowledge-verification":
      if (inputsAppKnowledgeVerification.programId.selectOption.length === 1) {
        inputsAppKnowledgeVerification.programId.selectOption.push(...inputsOptions);
      }
      break;
    case "knoweledge-test-record":
      if (inputsSearchKnoweledgeTestRecord.programId.selectOption.length === 1) {
        inputsSearchKnoweledgeTestRecord.programId.selectOption.push(...inputsOptions);
      }
      break;
    case "issuing-certificates/applicant-search":
      if (inputsFormSearchApplicant.programId.selectOption.length === 1) {
        inputsFormSearchApplicant.programId.selectOption.push(...inputsOptions);
      }
      break;
    default:
      break;
    case "knoweledge-test-record/add/searchPeople":
      if (inputsSearchPeopleForTest.programId.selectOption.length === 1) {
        inputsSearchPeopleForTest.programId.selectOption.push(...inputsOptions);
      }
      break;
  }
};

export const setInputsForGimsSections = (inputs) => {
  if (inputsHeadersSmallBoatsRegistration.section.selectOption.length === 1) {
    inputsHeadersSmallBoatsRegistration.section.selectOption.push(...inputs);
  }
  if (inputsRegInformChange.section.selectOption.length === 1) {
    inputsRegInformChange.section.selectOption.push(...inputs);
  }
  if (inputsProvisionInformation.section.selectOption.length === 1) {
    inputsProvisionInformation.section.selectOption.push(...inputs);
  }
  if (inputsHeadersDuplicateShipsTicket.section.selectOption.length === 1) {
    inputsHeadersDuplicateShipsTicket.section.selectOption.push(...inputs);
  }
  if (inputsHeadersShipsTicket.section.selectOption.length === 1) {
    inputsHeadersShipsTicket.section.selectOption.push(...inputs);
  }
  if (inputsHeadersTransportAccidentsReport.section.selectOption.length === 1) {
    inputsHeadersTransportAccidentsReport.section.selectOption.push(...inputs);
  }
  if (inputsTechnicalExamination.section.selectOption.length === 1) {
    inputsTechnicalExamination.section.selectOption.push(...inputs);
  }
  if (inputsApplicationTraining.section.selectOption.length === 1) {
    inputsApplicationTraining.section.selectOption.push(...inputs);
  }
  if (inputsRegisterOfTrainees.section.selectOption.length === 1) {
    inputsRegisterOfTrainees.section.selectOption.push(...inputs);
  }
  if (inputsAppKnowledgeVerification.section.selectOption.length === 1) {
    inputsAppKnowledgeVerification.section.selectOption.push(...inputs);
  }
  if (inputsSearchKnoweledgeTestRecord.section.selectOption.length === 1) {
    inputsSearchKnoweledgeTestRecord.section.selectOption.push(...inputs);
  }
  if (inputsIssuingCertificates.section.selectOption.length === 1) {
    inputsIssuingCertificates.section.selectOption.push(...inputs);
  }
  if (inputsFormSearchApplicant.section.selectOption.length === 1) {
    inputsFormSearchApplicant.section.selectOption.push(...inputs);
  }
  if (inputsSearchCertificatesForPrint.section.selectOption.length === 1) {
    inputsSearchCertificatesForPrint.section.selectOption.push(...inputs);
  }
  if (inputsInspectionTechnicalConditionBases.section.selectOption.length === 1) {
    inputsInspectionTechnicalConditionBases.section.selectOption.push(...inputs);
  }
  if (inputsExchangeCertificates.section.selectOption.length === 1) {
    inputsExchangeCertificates.section.selectOption.push(...inputs);
  }

  if (inputsLogbookAdministrativeProcedures.section.selectOption.length === 1) {
    inputsLogbookAdministrativeProcedures.section.selectOption.push(...inputs);
  }
};
export const setInputsForIssuanceCertificates = (inputs) => {
  if (inputsIssuingCertificates.status.selectOption.length === 1) {
    inputsIssuingCertificates.status.selectOption.push(...inputs);
  }
  if (inputsSearchCertificatesForPrint.status.selectOption.length === 1) {
    inputsSearchCertificatesForPrint.status.selectOption.push(...inputs);
  }
  if (inputsExchangeCertificates.status.selectOption.length === 1) {
    inputsExchangeCertificates.status.selectOption.push(...inputs);
  }
  if (inputsDuplicateCertificates.status.selectOption.length === 1) {
    inputsDuplicateCertificates.status.selectOption.push(...inputs);
  }
};

export const setCheckStatus = (inputs) => {
  if (inputsInspectionTechnicalConditionBases.checkStatus.selectOption.length === 1) {
    inputsInspectionTechnicalConditionBases.checkStatus.selectOption.push(...inputs);
  }
};

export const setOblast = (inputs) => {
  if (inputsSettlements.oblast.selectOption.length === 1) {
    inputsSettlements.oblast.selectOption.push(...inputs);
  }
};

export const setRayon = (inputs) => {
  inputsSettlements.rayon.selectOption = [{ value: 0, label: "Не выбрано", key: "rayon" }];
  inputsSettlements.rayon.selectOption.push(...inputs);
};

export const deleteRayon = () => {
  inputsSettlements.rayon.selectOption = [{ value: 0, label: "Не выбрано", key: "rayon" }];
};
